/* @jsx h */
import { useMenu } from "@app/vue/providers/Menu";
import { defineComponent, h, computed } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const PaymentSection = defineComponent({
  setup() {
    const { cart } = useMenu();
    const { t } = useLocalization();

    // Initialize cart.paymentMethod if not set
    if (!cart.cart.paymentMethod) {
      cart.cart.paymentMethod =
        cart.cart.serviceMethod === "dine-in" ? "online" : "online";
    }

    // Define available payment methods based on service method
    const paymentMethods = computed(() => {
      if (cart.cart.serviceMethod === "dine-in") {
        return [
          {
            value: "online",
            label: t("customer.checkout.pay_online"),
            description: t("customer.checkout.pay_online_copy"),
            icon: "credit_card",
          },
          {
            value: "cash",
            label: t("customer.checkout.pay_at_counter"),
            description: t("customer.checkout.pay_at_counter_copy"),
            icon: "payments",
          },
        ];
      } else {
        // For takeaway and delivery, only online payment
        return [
          {
            value: "online",
            label: t("customer.checkout.pay_online"),
            description: t("customer.checkout.pay_online_copy"),
            icon: "credit_card",
          },
        ];
      }
    });

    const handlePaymentMethodChange = (method: "online" | "cash") => {
      cart.cart.paymentMethod = method;
    };

    return () => (
      <div class="p-2 ">
        <h3 class="text-lg font-semibold mb-4">
          {t("customer.checkout.payment_method")}
        </h3>
        <div class="flex flex-col gap-3">
          {paymentMethods.value.map((method) => (
            <label
              key={method.value}
              class={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer ${
                cart.cart.paymentMethod === method.value ? "border-primary" : ""
              }`}
            >
              <input
                type="radio"
                name="payment"
                value={method.value}
                checked={cart.cart.paymentMethod === method.value}
                onChange={() =>
                  handlePaymentMethodChange(method.value as "online" | "cash")
                }
                class="radio radio-primary"
              />
              <div>
                <div class="font-medium">{method.label}</div>
                <div class="text-sm">{method.description}</div>
              </div>
              <span class="material-symbols-outlined ml-auto">
                {method.icon}
              </span>
            </label>
          ))}
        </div>
      </div>
    );
  },
});
